// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================
   pi-qa — Community Q&A tool (public widget, AB#9284)

   Ported from the PublicInput Frontend Public Design System handoff
   ("Community QA tool.html"). Everything is scoped under .pi-qa and
   tokens live on the scope class (NOT :root — the webpack postcss
   pipeline rewrites :root to :host). Fonts intentionally inherit the
   host page (customer branding varies). Subtle TEXT uses #5b6873
   (the prototype's #8997A1 fails WCAG AA on white); #8997A1 remains
   for decorative strokes only.
   ============================================================= */

.pi-qa {
  /* Blues darkened from the prototype's #0395FF/#0383e0: as text on white (and as the
     primary button background under white text) those fail WCAG AA. #0b5ed7 ≈ 5.4:1
     and #094db1 ≈ 7:1 against white; the original bright blue survives only in the
     translucent decorative washes below. */
  --pi-qa-blue: #0b5ed7;
  --pi-qa-blue-deep: #094db1;
  --pi-qa-blue-pale: #dbf1ff;
  --pi-qa-ink: #333;
  --pi-qa-muted: #696868;
  --pi-qa-subtle: #5b6873;
  --pi-qa-stroke: #8997a1;
  --pi-qa-border: #c4cdd4;
  --pi-qa-border-soft: #eaedef;
  --pi-qa-bg-tinted: #f5f8fa;
  --pi-qa-teal: #07afaa;
  --pi-qa-teal-deep: #056662;
  --pi-qa-danger: #c0392b;
  --pi-qa-danger-dark: #a52a1c;
  --pi-qa-radius-md: 6px;
  --pi-qa-radius-lg: 10px;
  --pi-qa-radius-xl: 14px;
  --pi-qa-radius-pill: 999px;

  /* Solid, full-alpha focus indicator — translucent rings fail 1.4.11 non-text contrast. */
  --pi-qa-focus: #0b5ed7;

  display: block;
  color: var(--pi-qa-ink);
}

/* visually hidden utility */
.pi-qa .pi-qa-vh {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

.pi-qa .pi-qa-hidden {
  display: none !important;
}

.pi-qa svg {
  width: 17px;
  height: 17px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
  vertical-align: -3px;
}

/* ---------- card shell ---------- */
.pi-qa__card {
  background: #fff;
  border: 1px solid var(--pi-qa-border-soft);
  border-radius: var(--pi-qa-radius-xl);
  overflow: hidden;
}

.pi-qa__head {
  padding: 24px 26px 0;
}

.pi-qa__heading {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
  color: var(--pi-qa-ink);
}

.pi-qa__intro {
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--pi-qa-muted);
  margin: 0 0 16px;
  max-width: 640px;
}

/* ---------- tabs ---------- */
.pi-qa__tabs {
  display: flex;
  gap: 8px;
  padding: 0 26px;
}

.pi-qa__tab {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  font-weight: 700;
  font-size: 15px;
  color: var(--pi-qa-ink);
  padding: 10px 6px 13px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
}

.pi-qa__tab:hover {
  color: var(--pi-qa-blue);
}

.pi-qa__tab[aria-selected="true"] {
  color: var(--pi-qa-blue);
  border-bottom-color: var(--pi-qa-blue);
}

.pi-qa__tab-count {
  font-weight: 600;
  font-size: 12px;
  background: rgba(3, 149, 255, 0.12);
  color: var(--pi-qa-blue-deep);
  border-radius: var(--pi-qa-radius-pill);
  padding: 1px 8px;
  margin-left: 4px;
}

.pi-qa__body {
  border-top: 1px solid var(--pi-qa-border-soft);
}

.pi-qa__panel {
  display: none;
  padding: 22px 26px 26px;
}

.pi-qa__panel--show {
  display: block;
}

/* ---------- controls row ---------- */
.pi-qa__controls {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.pi-qa__search {
  position: relative;
  flex: 1 1 240px;
  min-width: 200px;
}

.pi-qa__search svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  stroke: var(--pi-qa-stroke);
  pointer-events: none;
}

.pi-qa__search-input {
  width: 100%;
  font-size: 14.5px;
  padding: 10px 12px 10px 38px;
  border: 1px solid var(--pi-qa-border);
  border-radius: var(--pi-qa-radius-md);
  background: #fff;
  color: var(--pi-qa-ink);
}

.pi-qa__search-input:focus {
  outline: 3px solid var(--pi-qa-focus);
  outline-offset: 2px;
  border-color: var(--pi-qa-blue);
}

.pi-qa__ctl {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.pi-qa__ctl label {
  font-size: 12px;
  font-weight: 600;
  color: var(--pi-qa-muted);
}

.pi-qa__select {
  font-size: 13.5px;
  color: var(--pi-qa-ink);
  padding: 9px 11px;
  border: 1px solid var(--pi-qa-border);
  border-radius: var(--pi-qa-radius-md);
  background: #fff;
  cursor: pointer;
}

.pi-qa__select:focus {
  outline: 3px solid var(--pi-qa-focus);
  outline-offset: 2px;
  border-color: var(--pi-qa-blue);
}

.pi-qa__ask {
  margin-left: auto;
}

/* ---------- buttons ---------- */
.pi-qa__btn {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: var(--pi-qa-radius-lg);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
}

.pi-qa__btn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.2;
}

.pi-qa__btn--primary {
  background: var(--pi-qa-blue);
  color: #fff;
}

.pi-qa__btn--primary:hover {
  background: var(--pi-qa-blue-deep);
}

.pi-qa__btn--outline {
  background: #fff;
  color: var(--pi-qa-blue-deep);
  border: 1px solid var(--pi-qa-blue);
  padding: 9px 19px;
}

.pi-qa__btn--outline:hover {
  background: var(--pi-qa-blue-pale);
}

.pi-qa__btn--ghost {
  background: transparent;
  color: var(--pi-qa-muted);
  font-size: 13px;
  padding: 8px 14px;
}

.pi-qa__btn--ghost:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--pi-qa-ink);
}

.pi-qa__btn:focus,
.pi-qa__vote:focus,
.pi-qa__ansdisc:focus,
.pi-qa__tab:focus {
  outline: 3px solid var(--pi-qa-focus);
  outline-offset: 2px;
}

.pi-qa__btn:focus:not(:focus-visible),
.pi-qa__vote:focus:not(:focus-visible),
.pi-qa__ansdisc:focus:not(:focus-visible),
.pi-qa__tab:focus:not(:focus-visible) {
  outline: none;
}

.pi-qa__btn:focus-visible,
.pi-qa__vote:focus-visible,
.pi-qa__ansdisc:focus-visible,
.pi-qa__tab:focus-visible {
  outline: 3px solid var(--pi-qa-focus);
  outline-offset: 2px;
}

/* ---------- compose ---------- */
.pi-qa__compose {
  display: none;
  background: var(--pi-qa-bg-tinted);
  border: 1px solid var(--pi-qa-border-soft);
  border-radius: var(--pi-qa-radius-lg);
  padding: 18px;
  margin-bottom: 18px;
}

.pi-qa__compose--show {
  display: block;
  animation: pi-qa-fade 200ms ease-out;
}

.pi-qa__compose-h {
  font-weight: 700;
  font-size: 15px;
  margin: 0 0 3px;
}

.pi-qa__compose-sub {
  font-size: 13px;
  color: var(--pi-qa-muted);
  margin: 0 0 14px;
}

.pi-qa__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.pi-qa__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pi-qa__field--full {
  grid-column: 1 / -1;
}

.pi-qa__field label {
  font-size: 14px;
  color: var(--pi-qa-ink);
}

.pi-qa__field input,
.pi-qa__field textarea,
.pi-qa__field select {
  font-size: 15px;
  color: var(--pi-qa-ink);
  width: 100%;
  border: 1px solid var(--pi-qa-border);
  border-radius: var(--pi-qa-radius-md);
  padding: 11px 13px;
  background: #fff;
}

.pi-qa__field textarea {
  min-height: 84px;
  resize: vertical;
}

.pi-qa__field input:focus,
.pi-qa__field textarea:focus,
.pi-qa__field select:focus {
  outline: 3px solid var(--pi-qa-focus);
  outline-offset: 2px;
  border-color: var(--pi-qa-blue);
}

.pi-qa__err-msg {
  display: none;
  font-size: 12.5px;
  color: var(--pi-qa-danger);
}

.pi-qa__field--invalid input,
.pi-qa__field--invalid textarea {
  border-color: var(--pi-qa-danger);
  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.12);
}

.pi-qa__field--invalid .pi-qa__err-msg {
  display: block;
}

.pi-qa__charct {
  font-size: 12px;
  color: var(--pi-qa-subtle);
  text-align: right;
}

.pi-qa__compose-foot {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.pi-qa__compose-note {
  font-size: 12.5px;
  color: var(--pi-qa-subtle);
  margin-left: auto;
  max-width: 340px;
}

/* ---------- notices ---------- */
.pi-qa__notice {
  display: none;
  gap: 12px;
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: var(--pi-qa-radius-lg);
  align-items: flex-start;
}

.pi-qa__notice--show {
  display: flex;
  animation: pi-qa-fade 200ms ease-out;
}

.pi-qa__notice svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin-top: 1px;
}

.pi-qa__notice-t {
  font-weight: 700;
  font-size: 14px;
  margin: 0 0 3px;
}

.pi-qa__notice-d {
  font-size: 13.5px;
  line-height: 1.55;
  margin: 0;
}

.pi-qa__notice--ok {
  background: rgba(7, 175, 170, 0.1);
  border: 1px solid rgba(7, 175, 170, 0.35);
}

.pi-qa__notice--ok svg {
  stroke: var(--pi-qa-teal);
}

.pi-qa__notice--ok .pi-qa__notice-t {
  color: var(--pi-qa-teal-deep);
}

.pi-qa__notice--ok .pi-qa__notice-d {
  color: #0a7d78;
}

.pi-qa__notice--err {
  background: #fdecea;
  border: 1px solid #f2b8b1;
}

.pi-qa__notice--err svg {
  stroke: var(--pi-qa-danger);
}

.pi-qa__notice--err .pi-qa__notice-t {
  color: var(--pi-qa-danger-dark);
}

.pi-qa__notice--err .pi-qa__notice-d {
  color: #97382c;
}

.pi-qa__notice--err .pi-qa__btn {
  margin-top: 8px;
}
@keyframes pi-qa-fade {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

/* ---------- question list ---------- */
.pi-qa__rescount {
  font-size: 13px;
  color: var(--pi-qa-muted);
  margin: 0 0 10px;
}

.pi-qa__list {
  border: 1px solid var(--pi-qa-border-soft);
  border-radius: var(--pi-qa-radius-lg);
  overflow: hidden;
  background: #fff;
}

.pi-qa__row {
  border-top: 1px solid var(--pi-qa-border-soft);
}

.pi-qa__list > .pi-qa__row:first-child {
  border-top: 0;
}

.pi-qa__row-main {
  display: grid;
  grid-template-columns: 64px 1fr;
  gap: 16px;
  padding: 16px 18px;
}

.pi-qa__vote {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  cursor: pointer;
  align-self: start;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  width: 64px;
  min-height: 44px;
  padding: 8px 4px 7px;
  background: #fff;
  border: 1px solid var(--pi-qa-border);
  border-radius: var(--pi-qa-radius-lg);
  color: var(--pi-qa-muted);
}

.pi-qa__vote svg {
  width: 17px;
  height: 17px;
  stroke-width: 2.4;
}

.pi-qa__vote-n {
  font-weight: 700;
  font-size: 16px;
  color: var(--pi-qa-ink);
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.pi-qa__vote-l {
  font-size: 10.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.pi-qa__vote:hover {
  border-color: var(--pi-qa-blue);
  color: var(--pi-qa-blue);
}

.pi-qa__vote[aria-pressed="true"] {
  background: var(--pi-qa-blue-pale);
  border-color: var(--pi-qa-blue);
  color: var(--pi-qa-blue-deep);
}

.pi-qa__vote[aria-pressed="true"] .pi-qa__vote-n {
  color: var(--pi-qa-blue-deep);
}

.pi-qa__row-body {
  min-width: 0;
}

.pi-qa__row-top {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.pi-qa__qtext {
  font-weight: 600;
  font-size: 15.5px;
  line-height: 1.5;
  color: var(--pi-qa-ink);
  margin: 0;
  flex: 1;
  overflow-wrap: anywhere;
}

.pi-qa__pill {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  font-size: 11.5px;
  padding: 3px 10px;
  border-radius: var(--pi-qa-radius-pill);
  white-space: nowrap;
  margin-top: 1px;
}

.pi-qa__pill svg {
  width: 12px;
  height: 12px;
  stroke-width: 2.6;
}

.pi-qa__pill--open {
  background: var(--pi-qa-border-soft);
  color: #4a545c;
}

.pi-qa__pill--answered {
  background: rgba(7, 175, 170, 0.12);
  color: var(--pi-qa-teal-deep);
}

.pi-qa__meta {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 6px;
  font-size: 12.5px;
  color: var(--pi-qa-subtle);
}

.pi-qa__dot {
  color: var(--pi-qa-border);
}

.pi-qa__cat-chip {
  color: var(--pi-qa-blue-deep);
  background: rgba(3, 149, 255, 0.09);
  border-radius: var(--pi-qa-radius-pill);
  padding: 1px 9px;
  font-weight: 600;
}

.pi-qa__views {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.pi-qa__views svg {
  width: 13px;
  height: 13px;
}

/* answer disclosure */
.pi-qa__ansdisc {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  background: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 10px;
  padding: 8px 0;
  min-height: 44px;
  font-weight: 700;
  font-size: 13.5px;
  color: var(--pi-qa-blue-deep);
}

.pi-qa__ansdisc svg {
  width: 15px;
  height: 15px;
  stroke-width: 2.2;
  transition: transform 150ms ease;
}

.pi-qa__ansdisc[aria-expanded="true"] svg {
  transform: rotate(180deg);
}

.pi-qa__ansdisc:hover {
  text-decoration: underline;
}

.pi-qa__awaiting {
  margin: 10px 0 0;
  font-size: 13px;
  color: var(--pi-qa-subtle);
  font-style: italic;
}

.pi-qa__answer {
  display: none;
  margin-top: 12px;
  background: var(--pi-qa-blue-pale);
  border-radius: var(--pi-qa-radius-lg);
  padding: 15px 17px;
}

.pi-qa__answer--show {
  display: block;
  animation: pi-qa-fade 180ms ease-out;
}

.pi-qa__ans-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 9px;
}

.pi-qa__ans-who {
  display: flex;
  flex-direction: column;
}

.pi-qa__ans-name {
  font-weight: 700;
  font-size: 14px;
  color: var(--pi-qa-ink);
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.pi-qa__ans-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  font-size: 10.5px;
  color: var(--pi-qa-blue-deep);
  background: #fff;
  padding: 2px 8px;
  border-radius: var(--pi-qa-radius-pill);
}

.pi-qa__ans-badge svg {
  width: 11px;
  height: 11px;
  stroke-width: 2.6;
}

.pi-qa__ans-role {
  font-size: 12.5px;
  color: var(--pi-qa-muted);
}

.pi-qa__ans-body {
  font-size: 14px;
  line-height: 1.62;
  color: var(--pi-qa-ink);
  margin: 0;
  overflow-wrap: anywhere;
}

.pi-qa__ans-date {
  font-size: 12px;
  color: var(--pi-qa-subtle);
  margin: 8px 0 0;
}

/* avatars (palette classes — no inline styles) */
.pi-qa-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13.5px;
  color: #fff;
  flex: 0 0 38px;
  overflow: hidden;
}

.pi-qa-avatar--lg {
  width: 48px;
  height: 48px;
  font-size: 16px;
  flex: 0 0 48px;
}

.pi-qa-avatar__img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  display: block;
}

.pi-qa-avatar--0 {
  background: #0383e0;
}

.pi-qa-avatar--1 {
  background: #07afaa;
}

.pi-qa-avatar--2 {
  background: #7a5ae0;
}

.pi-qa-avatar--3 {
  background: #c25a08;
}

.pi-qa-avatar--4 {
  background: #2c7a4b;
}

.pi-qa-avatar--5 {
  background: #b8358a;
}

/* pending (author-only) question */
.pi-qa__row--pending {
  background: var(--pi-qa-bg-tinted);
}

.pi-qa__row--pending .pi-qa__qtext {
  color: var(--pi-qa-muted);
}

.pi-qa__pending-note {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 9px;
  font-size: 12.5px;
  color: var(--pi-qa-muted);
  background: var(--pi-qa-border-soft);
  padding: 7px 11px;
  border-radius: var(--pi-qa-radius-md);
}

.pi-qa__pending-note svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  margin-top: 1px;
}

/* empty */
.pi-qa__empty {
  display: none;
  text-align: center;
  padding: 46px 20px;
}

.pi-qa__empty--show {
  display: block;
}

.pi-qa__empty svg {
  width: 42px;
  height: 42px;
  stroke: var(--pi-qa-border);
  stroke-width: 1.6;
  margin-bottom: 10px;
}

.pi-qa__empty-t {
  font-weight: 700;
  font-size: 16px;
  color: var(--pi-qa-ink);
  margin: 0 0 4px;
}

.pi-qa__empty-d {
  font-size: 14px;
  color: var(--pi-qa-muted);
  margin: 0 0 16px;
}

.pi-qa__more-wrap {
  display: flex;
  justify-content: center;
  padding: 18px 0 0;
}

/* ---------- who's listening ---------- */
.pi-qa__wl-intro {
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--pi-qa-muted);
  margin: 0 0 18px;
  max-width: 620px;
}

.pi-qa__wl-empty {
  font-size: 14px;
  color: var(--pi-qa-subtle);
  font-style: italic;
}

.pi-qa__wl-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
}

.pi-qa__wl-card {
  background: var(--pi-qa-bg-tinted);
  border: 1px solid var(--pi-qa-border-soft);
  border-radius: var(--pi-qa-radius-lg);
  padding: 18px;
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.pi-qa__wl-name {
  font-weight: 700;
  font-size: 15px;
  color: var(--pi-qa-ink);
  margin: 0;
}

.pi-qa__wl-role {
  font-size: 13px;
  color: var(--pi-qa-muted);
  margin: 1px 0 6px;
}

.pi-qa__wl-stat {
  font-size: 12.5px;
  color: var(--pi-qa-teal-deep);
  font-weight: 600;
}

/* ---------- mobile ---------- */
@media (max-width: 720px) {
  .pi-qa__panel {
    padding: 18px 16px 22px;
  }

  .pi-qa__head {
    padding: 20px 16px 0;
  }

  .pi-qa__tabs {
    padding: 0 16px;
  }

  .pi-qa__controls .pi-qa__ctl {
    flex: 1 1 30%;
  }

  .pi-qa__controls .pi-qa__ask {
    margin-left: 0;
    flex: 1 1 100%;
    justify-content: center;
  }

  .pi-qa__search {
    flex-basis: 100%;
  }

  .pi-qa__fields {
    grid-template-columns: 1fr;
  }

  .pi-qa__row-main {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 14px;
  }

  .pi-qa__vote {
    flex-direction: row;
    width: auto;
    align-self: flex-start;
    gap: 7px;
    padding: 7px 14px;
    order: 2;
  }

  .pi-qa__vote-l {
    font-size: 11px;
  }

  .pi-qa__row-body {
    order: 1;
  }

  .pi-qa__row-top {
    flex-direction: column-reverse;
    gap: 7px;
  }

  .pi-qa__compose-note {
    margin-left: 0;
    max-width: none;
  }
}

/* ---------- editor placeholder / preview ---------- */
.pi-qa__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 20px;
  border: 2px dashed #c4cdd4;
  border-radius: 10px;
  color: #5b6873;
  text-align: center;
  font-size: 14px;
}

.pi-qa__placeholder-icon {
  font-size: 28px;
  color: #8997a1;
}

.pi-qa__placeholder p {
  margin: 0;
}

.pi-qa--preview .pi-qa__controls {
  pointer-events: none;
}

.pi-qa--preview .pi-qa__row-main {
  grid-template-columns: auto 1fr;
  align-items: center;
}

@media (prefers-reduced-motion: reduce) {
  .pi-qa__compose--show,
  .pi-qa__notice--show,
  .pi-qa__answer--show {
    animation: none;
  }

  .pi-qa__ansdisc svg {
    transition: none;
  }
}

.pi-qa__more-error {
  margin: 8px 0 0;
  color: var(--pi-qa-danger-dark);
  font-size: 0.875rem;
}
`, "",{"version":3,"sources":["webpack://./Content/qa-tool.css"],"names":[],"mappings":"AAAA;;;;;;;;;;kEAUkE;;AAElE;EACE;;;2CAGyC;EACzC,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;;EAE1B,yFAAyF;EACzF,sBAAsB;;EAEtB,cAAc;EACd,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,qCAAqC;EACrC,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,qCAAqC;EACrC,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;;EAIE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;EAGE,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB","sourcesContent":["/* =============================================================\r\n   pi-qa — Community Q&A tool (public widget, AB#9284)\r\n\r\n   Ported from the PublicInput Frontend Public Design System handoff\r\n   (\"Community QA tool.html\"). Everything is scoped under .pi-qa and\r\n   tokens live on the scope class (NOT :root — the webpack postcss\r\n   pipeline rewrites :root to :host). Fonts intentionally inherit the\r\n   host page (customer branding varies). Subtle TEXT uses #5b6873\r\n   (the prototype's #8997A1 fails WCAG AA on white); #8997A1 remains\r\n   for decorative strokes only.\r\n   ============================================================= */\r\n\r\n.pi-qa {\r\n  /* Blues darkened from the prototype's #0395FF/#0383e0: as text on white (and as the\r\n     primary button background under white text) those fail WCAG AA. #0b5ed7 ≈ 5.4:1\r\n     and #094db1 ≈ 7:1 against white; the original bright blue survives only in the\r\n     translucent decorative washes below. */\r\n  --pi-qa-blue: #0b5ed7;\r\n  --pi-qa-blue-deep: #094db1;\r\n  --pi-qa-blue-pale: #dbf1ff;\r\n  --pi-qa-ink: #333;\r\n  --pi-qa-muted: #696868;\r\n  --pi-qa-subtle: #5b6873;\r\n  --pi-qa-stroke: #8997a1;\r\n  --pi-qa-border: #c4cdd4;\r\n  --pi-qa-border-soft: #eaedef;\r\n  --pi-qa-bg-tinted: #f5f8fa;\r\n  --pi-qa-teal: #07afaa;\r\n  --pi-qa-teal-deep: #056662;\r\n  --pi-qa-danger: #c0392b;\r\n  --pi-qa-danger-dark: #a52a1c;\r\n  --pi-qa-radius-md: 6px;\r\n  --pi-qa-radius-lg: 10px;\r\n  --pi-qa-radius-xl: 14px;\r\n  --pi-qa-radius-pill: 999px;\r\n\r\n  /* Solid, full-alpha focus indicator — translucent rings fail 1.4.11 non-text contrast. */\r\n  --pi-qa-focus: #0b5ed7;\r\n\r\n  display: block;\r\n  color: var(--pi-qa-ink);\r\n}\r\n\r\n/* visually hidden utility */\r\n.pi-qa .pi-qa-vh {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0 0 0 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.pi-qa .pi-qa-hidden {\r\n  display: none !important;\r\n}\r\n\r\n.pi-qa svg {\r\n  width: 17px;\r\n  height: 17px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2;\r\n  vertical-align: -3px;\r\n}\r\n\r\n/* ---------- card shell ---------- */\r\n.pi-qa__card {\r\n  background: #fff;\r\n  border: 1px solid var(--pi-qa-border-soft);\r\n  border-radius: var(--pi-qa-radius-xl);\r\n  overflow: hidden;\r\n}\r\n\r\n.pi-qa__head {\r\n  padding: 24px 26px 0;\r\n}\r\n\r\n.pi-qa__heading {\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  margin: 0 0 6px;\r\n  letter-spacing: -0.01em;\r\n  color: var(--pi-qa-ink);\r\n}\r\n\r\n.pi-qa__intro {\r\n  font-size: 14.5px;\r\n  line-height: 1.6;\r\n  color: var(--pi-qa-muted);\r\n  margin: 0 0 16px;\r\n  max-width: 640px;\r\n}\r\n\r\n/* ---------- tabs ---------- */\r\n.pi-qa__tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 0 26px;\r\n}\r\n\r\n.pi-qa__tab {\r\n  appearance: none;\r\n  background: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  color: var(--pi-qa-ink);\r\n  padding: 10px 6px 13px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-bottom: 3px solid transparent;\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.pi-qa__tab:hover {\r\n  color: var(--pi-qa-blue);\r\n}\r\n\r\n.pi-qa__tab[aria-selected=\"true\"] {\r\n  color: var(--pi-qa-blue);\r\n  border-bottom-color: var(--pi-qa-blue);\r\n}\r\n\r\n.pi-qa__tab-count {\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  background: rgba(3, 149, 255, 0.12);\r\n  color: var(--pi-qa-blue-deep);\r\n  border-radius: var(--pi-qa-radius-pill);\r\n  padding: 1px 8px;\r\n  margin-left: 4px;\r\n}\r\n\r\n.pi-qa__body {\r\n  border-top: 1px solid var(--pi-qa-border-soft);\r\n}\r\n\r\n.pi-qa__panel {\r\n  display: none;\r\n  padding: 22px 26px 26px;\r\n}\r\n\r\n.pi-qa__panel--show {\r\n  display: block;\r\n}\r\n\r\n/* ---------- controls row ---------- */\r\n.pi-qa__controls {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.pi-qa__search {\r\n  position: relative;\r\n  flex: 1 1 240px;\r\n  min-width: 200px;\r\n}\r\n\r\n.pi-qa__search svg {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  stroke: var(--pi-qa-stroke);\r\n  pointer-events: none;\r\n}\r\n\r\n.pi-qa__search-input {\r\n  width: 100%;\r\n  font-size: 14.5px;\r\n  padding: 10px 12px 10px 38px;\r\n  border: 1px solid var(--pi-qa-border);\r\n  border-radius: var(--pi-qa-radius-md);\r\n  background: #fff;\r\n  color: var(--pi-qa-ink);\r\n}\r\n\r\n.pi-qa__search-input:focus {\r\n  outline: 3px solid var(--pi-qa-focus);\r\n  outline-offset: 2px;\r\n  border-color: var(--pi-qa-blue);\r\n}\r\n\r\n.pi-qa__ctl {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.pi-qa__ctl label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--pi-qa-muted);\r\n}\r\n\r\n.pi-qa__select {\r\n  font-size: 13.5px;\r\n  color: var(--pi-qa-ink);\r\n  padding: 9px 11px;\r\n  border: 1px solid var(--pi-qa-border);\r\n  border-radius: var(--pi-qa-radius-md);\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.pi-qa__select:focus {\r\n  outline: 3px solid var(--pi-qa-focus);\r\n  outline-offset: 2px;\r\n  border-color: var(--pi-qa-blue);\r\n}\r\n\r\n.pi-qa__ask {\r\n  margin-left: auto;\r\n}\r\n\r\n/* ---------- buttons ---------- */\r\n.pi-qa__btn {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  padding: 10px 20px;\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-height: 44px;\r\n}\r\n\r\n.pi-qa__btn svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  stroke-width: 2.2;\r\n}\r\n\r\n.pi-qa__btn--primary {\r\n  background: var(--pi-qa-blue);\r\n  color: #fff;\r\n}\r\n\r\n.pi-qa__btn--primary:hover {\r\n  background: var(--pi-qa-blue-deep);\r\n}\r\n\r\n.pi-qa__btn--outline {\r\n  background: #fff;\r\n  color: var(--pi-qa-blue-deep);\r\n  border: 1px solid var(--pi-qa-blue);\r\n  padding: 9px 19px;\r\n}\r\n\r\n.pi-qa__btn--outline:hover {\r\n  background: var(--pi-qa-blue-pale);\r\n}\r\n\r\n.pi-qa__btn--ghost {\r\n  background: transparent;\r\n  color: var(--pi-qa-muted);\r\n  font-size: 13px;\r\n  padding: 8px 14px;\r\n}\r\n\r\n.pi-qa__btn--ghost:hover {\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: var(--pi-qa-ink);\r\n}\r\n\r\n.pi-qa__btn:focus,\r\n.pi-qa__vote:focus,\r\n.pi-qa__ansdisc:focus,\r\n.pi-qa__tab:focus {\r\n  outline: 3px solid var(--pi-qa-focus);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.pi-qa__btn:focus:not(:focus-visible),\r\n.pi-qa__vote:focus:not(:focus-visible),\r\n.pi-qa__ansdisc:focus:not(:focus-visible),\r\n.pi-qa__tab:focus:not(:focus-visible) {\r\n  outline: none;\r\n}\r\n\r\n.pi-qa__btn:focus-visible,\r\n.pi-qa__vote:focus-visible,\r\n.pi-qa__ansdisc:focus-visible,\r\n.pi-qa__tab:focus-visible {\r\n  outline: 3px solid var(--pi-qa-focus);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* ---------- compose ---------- */\r\n.pi-qa__compose {\r\n  display: none;\r\n  background: var(--pi-qa-bg-tinted);\r\n  border: 1px solid var(--pi-qa-border-soft);\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  padding: 18px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.pi-qa__compose--show {\r\n  display: block;\r\n  animation: pi-qa-fade 200ms ease-out;\r\n}\r\n\r\n.pi-qa__compose-h {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  margin: 0 0 3px;\r\n}\r\n\r\n.pi-qa__compose-sub {\r\n  font-size: 13px;\r\n  color: var(--pi-qa-muted);\r\n  margin: 0 0 14px;\r\n}\r\n\r\n.pi-qa__fields {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 14px;\r\n}\r\n\r\n.pi-qa__field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.pi-qa__field--full {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.pi-qa__field label {\r\n  font-size: 14px;\r\n  color: var(--pi-qa-ink);\r\n}\r\n\r\n.pi-qa__field input,\r\n.pi-qa__field textarea,\r\n.pi-qa__field select {\r\n  font-size: 15px;\r\n  color: var(--pi-qa-ink);\r\n  width: 100%;\r\n  border: 1px solid var(--pi-qa-border);\r\n  border-radius: var(--pi-qa-radius-md);\r\n  padding: 11px 13px;\r\n  background: #fff;\r\n}\r\n\r\n.pi-qa__field textarea {\r\n  min-height: 84px;\r\n  resize: vertical;\r\n}\r\n\r\n.pi-qa__field input:focus,\r\n.pi-qa__field textarea:focus,\r\n.pi-qa__field select:focus {\r\n  outline: 3px solid var(--pi-qa-focus);\r\n  outline-offset: 2px;\r\n  border-color: var(--pi-qa-blue);\r\n}\r\n\r\n.pi-qa__err-msg {\r\n  display: none;\r\n  font-size: 12.5px;\r\n  color: var(--pi-qa-danger);\r\n}\r\n\r\n.pi-qa__field--invalid input,\r\n.pi-qa__field--invalid textarea {\r\n  border-color: var(--pi-qa-danger);\r\n  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.12);\r\n}\r\n\r\n.pi-qa__field--invalid .pi-qa__err-msg {\r\n  display: block;\r\n}\r\n\r\n.pi-qa__charct {\r\n  font-size: 12px;\r\n  color: var(--pi-qa-subtle);\r\n  text-align: right;\r\n}\r\n\r\n.pi-qa__compose-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pi-qa__compose-note {\r\n  font-size: 12.5px;\r\n  color: var(--pi-qa-subtle);\r\n  margin-left: auto;\r\n  max-width: 340px;\r\n}\r\n\r\n/* ---------- notices ---------- */\r\n.pi-qa__notice {\r\n  display: none;\r\n  gap: 12px;\r\n  margin-bottom: 18px;\r\n  padding: 14px 16px;\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  align-items: flex-start;\r\n}\r\n\r\n.pi-qa__notice--show {\r\n  display: flex;\r\n  animation: pi-qa-fade 200ms ease-out;\r\n}\r\n\r\n.pi-qa__notice svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex: 0 0 20px;\r\n  margin-top: 1px;\r\n}\r\n\r\n.pi-qa__notice-t {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  margin: 0 0 3px;\r\n}\r\n\r\n.pi-qa__notice-d {\r\n  font-size: 13.5px;\r\n  line-height: 1.55;\r\n  margin: 0;\r\n}\r\n\r\n.pi-qa__notice--ok {\r\n  background: rgba(7, 175, 170, 0.1);\r\n  border: 1px solid rgba(7, 175, 170, 0.35);\r\n}\r\n\r\n.pi-qa__notice--ok svg {\r\n  stroke: var(--pi-qa-teal);\r\n}\r\n\r\n.pi-qa__notice--ok .pi-qa__notice-t {\r\n  color: var(--pi-qa-teal-deep);\r\n}\r\n\r\n.pi-qa__notice--ok .pi-qa__notice-d {\r\n  color: #0a7d78;\r\n}\r\n\r\n.pi-qa__notice--err {\r\n  background: #fdecea;\r\n  border: 1px solid #f2b8b1;\r\n}\r\n\r\n.pi-qa__notice--err svg {\r\n  stroke: var(--pi-qa-danger);\r\n}\r\n\r\n.pi-qa__notice--err .pi-qa__notice-t {\r\n  color: var(--pi-qa-danger-dark);\r\n}\r\n\r\n.pi-qa__notice--err .pi-qa__notice-d {\r\n  color: #97382c;\r\n}\r\n\r\n.pi-qa__notice--err .pi-qa__btn {\r\n  margin-top: 8px;\r\n}\r\n@keyframes pi-qa-fade {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n/* ---------- question list ---------- */\r\n.pi-qa__rescount {\r\n  font-size: 13px;\r\n  color: var(--pi-qa-muted);\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.pi-qa__list {\r\n  border: 1px solid var(--pi-qa-border-soft);\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n\r\n.pi-qa__row {\r\n  border-top: 1px solid var(--pi-qa-border-soft);\r\n}\r\n\r\n.pi-qa__list > .pi-qa__row:first-child {\r\n  border-top: 0;\r\n}\r\n\r\n.pi-qa__row-main {\r\n  display: grid;\r\n  grid-template-columns: 64px 1fr;\r\n  gap: 16px;\r\n  padding: 16px 18px;\r\n}\r\n\r\n.pi-qa__vote {\r\n  appearance: none;\r\n  cursor: pointer;\r\n  align-self: start;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1px;\r\n  width: 64px;\r\n  min-height: 44px;\r\n  padding: 8px 4px 7px;\r\n  background: #fff;\r\n  border: 1px solid var(--pi-qa-border);\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  color: var(--pi-qa-muted);\r\n}\r\n\r\n.pi-qa__vote svg {\r\n  width: 17px;\r\n  height: 17px;\r\n  stroke-width: 2.4;\r\n}\r\n\r\n.pi-qa__vote-n {\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  color: var(--pi-qa-ink);\r\n  line-height: 1.2;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.pi-qa__vote-l {\r\n  font-size: 10.5px;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.pi-qa__vote:hover {\r\n  border-color: var(--pi-qa-blue);\r\n  color: var(--pi-qa-blue);\r\n}\r\n\r\n.pi-qa__vote[aria-pressed=\"true\"] {\r\n  background: var(--pi-qa-blue-pale);\r\n  border-color: var(--pi-qa-blue);\r\n  color: var(--pi-qa-blue-deep);\r\n}\r\n\r\n.pi-qa__vote[aria-pressed=\"true\"] .pi-qa__vote-n {\r\n  color: var(--pi-qa-blue-deep);\r\n}\r\n\r\n.pi-qa__row-body {\r\n  min-width: 0;\r\n}\r\n\r\n.pi-qa__row-top {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.pi-qa__qtext {\r\n  font-weight: 600;\r\n  font-size: 15.5px;\r\n  line-height: 1.5;\r\n  color: var(--pi-qa-ink);\r\n  margin: 0;\r\n  flex: 1;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.pi-qa__pill {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-weight: 700;\r\n  font-size: 11.5px;\r\n  padding: 3px 10px;\r\n  border-radius: var(--pi-qa-radius-pill);\r\n  white-space: nowrap;\r\n  margin-top: 1px;\r\n}\r\n\r\n.pi-qa__pill svg {\r\n  width: 12px;\r\n  height: 12px;\r\n  stroke-width: 2.6;\r\n}\r\n\r\n.pi-qa__pill--open {\r\n  background: var(--pi-qa-border-soft);\r\n  color: #4a545c;\r\n}\r\n\r\n.pi-qa__pill--answered {\r\n  background: rgba(7, 175, 170, 0.12);\r\n  color: var(--pi-qa-teal-deep);\r\n}\r\n\r\n.pi-qa__meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  flex-wrap: wrap;\r\n  margin-top: 6px;\r\n  font-size: 12.5px;\r\n  color: var(--pi-qa-subtle);\r\n}\r\n\r\n.pi-qa__dot {\r\n  color: var(--pi-qa-border);\r\n}\r\n\r\n.pi-qa__cat-chip {\r\n  color: var(--pi-qa-blue-deep);\r\n  background: rgba(3, 149, 255, 0.09);\r\n  border-radius: var(--pi-qa-radius-pill);\r\n  padding: 1px 9px;\r\n  font-weight: 600;\r\n}\r\n\r\n.pi-qa__views {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.pi-qa__views svg {\r\n  width: 13px;\r\n  height: 13px;\r\n}\r\n\r\n/* answer disclosure */\r\n.pi-qa__ansdisc {\r\n  appearance: none;\r\n  border: 0;\r\n  background: none;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-top: 10px;\r\n  padding: 8px 0;\r\n  min-height: 44px;\r\n  font-weight: 700;\r\n  font-size: 13.5px;\r\n  color: var(--pi-qa-blue-deep);\r\n}\r\n\r\n.pi-qa__ansdisc svg {\r\n  width: 15px;\r\n  height: 15px;\r\n  stroke-width: 2.2;\r\n  transition: transform 150ms ease;\r\n}\r\n\r\n.pi-qa__ansdisc[aria-expanded=\"true\"] svg {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.pi-qa__ansdisc:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.pi-qa__awaiting {\r\n  margin: 10px 0 0;\r\n  font-size: 13px;\r\n  color: var(--pi-qa-subtle);\r\n  font-style: italic;\r\n}\r\n\r\n.pi-qa__answer {\r\n  display: none;\r\n  margin-top: 12px;\r\n  background: var(--pi-qa-blue-pale);\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  padding: 15px 17px;\r\n}\r\n\r\n.pi-qa__answer--show {\r\n  display: block;\r\n  animation: pi-qa-fade 180ms ease-out;\r\n}\r\n\r\n.pi-qa__ans-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  margin-bottom: 9px;\r\n}\r\n\r\n.pi-qa__ans-who {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pi-qa__ans-name {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  color: var(--pi-qa-ink);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pi-qa__ans-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-weight: 700;\r\n  font-size: 10.5px;\r\n  color: var(--pi-qa-blue-deep);\r\n  background: #fff;\r\n  padding: 2px 8px;\r\n  border-radius: var(--pi-qa-radius-pill);\r\n}\r\n\r\n.pi-qa__ans-badge svg {\r\n  width: 11px;\r\n  height: 11px;\r\n  stroke-width: 2.6;\r\n}\r\n\r\n.pi-qa__ans-role {\r\n  font-size: 12.5px;\r\n  color: var(--pi-qa-muted);\r\n}\r\n\r\n.pi-qa__ans-body {\r\n  font-size: 14px;\r\n  line-height: 1.62;\r\n  color: var(--pi-qa-ink);\r\n  margin: 0;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.pi-qa__ans-date {\r\n  font-size: 12px;\r\n  color: var(--pi-qa-subtle);\r\n  margin: 8px 0 0;\r\n}\r\n\r\n/* avatars (palette classes — no inline styles) */\r\n.pi-qa-avatar {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  font-size: 13.5px;\r\n  color: #fff;\r\n  flex: 0 0 38px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pi-qa-avatar--lg {\r\n  width: 48px;\r\n  height: 48px;\r\n  font-size: 16px;\r\n  flex: 0 0 48px;\r\n}\r\n\r\n.pi-qa-avatar__img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.pi-qa-avatar--0 {\r\n  background: #0383e0;\r\n}\r\n\r\n.pi-qa-avatar--1 {\r\n  background: #07afaa;\r\n}\r\n\r\n.pi-qa-avatar--2 {\r\n  background: #7a5ae0;\r\n}\r\n\r\n.pi-qa-avatar--3 {\r\n  background: #c25a08;\r\n}\r\n\r\n.pi-qa-avatar--4 {\r\n  background: #2c7a4b;\r\n}\r\n\r\n.pi-qa-avatar--5 {\r\n  background: #b8358a;\r\n}\r\n\r\n/* pending (author-only) question */\r\n.pi-qa__row--pending {\r\n  background: var(--pi-qa-bg-tinted);\r\n}\r\n\r\n.pi-qa__row--pending .pi-qa__qtext {\r\n  color: var(--pi-qa-muted);\r\n}\r\n\r\n.pi-qa__pending-note {\r\n  display: inline-flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  margin-top: 9px;\r\n  font-size: 12.5px;\r\n  color: var(--pi-qa-muted);\r\n  background: var(--pi-qa-border-soft);\r\n  padding: 7px 11px;\r\n  border-radius: var(--pi-qa-radius-md);\r\n}\r\n\r\n.pi-qa__pending-note svg {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex: 0 0 14px;\r\n  margin-top: 1px;\r\n}\r\n\r\n/* empty */\r\n.pi-qa__empty {\r\n  display: none;\r\n  text-align: center;\r\n  padding: 46px 20px;\r\n}\r\n\r\n.pi-qa__empty--show {\r\n  display: block;\r\n}\r\n\r\n.pi-qa__empty svg {\r\n  width: 42px;\r\n  height: 42px;\r\n  stroke: var(--pi-qa-border);\r\n  stroke-width: 1.6;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.pi-qa__empty-t {\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  color: var(--pi-qa-ink);\r\n  margin: 0 0 4px;\r\n}\r\n\r\n.pi-qa__empty-d {\r\n  font-size: 14px;\r\n  color: var(--pi-qa-muted);\r\n  margin: 0 0 16px;\r\n}\r\n\r\n.pi-qa__more-wrap {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 18px 0 0;\r\n}\r\n\r\n/* ---------- who's listening ---------- */\r\n.pi-qa__wl-intro {\r\n  font-size: 14.5px;\r\n  line-height: 1.6;\r\n  color: var(--pi-qa-muted);\r\n  margin: 0 0 18px;\r\n  max-width: 620px;\r\n}\r\n\r\n.pi-qa__wl-empty {\r\n  font-size: 14px;\r\n  color: var(--pi-qa-subtle);\r\n  font-style: italic;\r\n}\r\n\r\n.pi-qa__wl-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n  gap: 14px;\r\n}\r\n\r\n.pi-qa__wl-card {\r\n  background: var(--pi-qa-bg-tinted);\r\n  border: 1px solid var(--pi-qa-border-soft);\r\n  border-radius: var(--pi-qa-radius-lg);\r\n  padding: 18px;\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.pi-qa__wl-name {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  color: var(--pi-qa-ink);\r\n  margin: 0;\r\n}\r\n\r\n.pi-qa__wl-role {\r\n  font-size: 13px;\r\n  color: var(--pi-qa-muted);\r\n  margin: 1px 0 6px;\r\n}\r\n\r\n.pi-qa__wl-stat {\r\n  font-size: 12.5px;\r\n  color: var(--pi-qa-teal-deep);\r\n  font-weight: 600;\r\n}\r\n\r\n/* ---------- mobile ---------- */\r\n@media (max-width: 720px) {\r\n  .pi-qa__panel {\r\n    padding: 18px 16px 22px;\r\n  }\r\n\r\n  .pi-qa__head {\r\n    padding: 20px 16px 0;\r\n  }\r\n\r\n  .pi-qa__tabs {\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .pi-qa__controls .pi-qa__ctl {\r\n    flex: 1 1 30%;\r\n  }\r\n\r\n  .pi-qa__controls .pi-qa__ask {\r\n    margin-left: 0;\r\n    flex: 1 1 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .pi-qa__search {\r\n    flex-basis: 100%;\r\n  }\r\n\r\n  .pi-qa__fields {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .pi-qa__row-main {\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n    padding: 14px;\r\n  }\r\n\r\n  .pi-qa__vote {\r\n    flex-direction: row;\r\n    width: auto;\r\n    align-self: flex-start;\r\n    gap: 7px;\r\n    padding: 7px 14px;\r\n    order: 2;\r\n  }\r\n\r\n  .pi-qa__vote-l {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .pi-qa__row-body {\r\n    order: 1;\r\n  }\r\n\r\n  .pi-qa__row-top {\r\n    flex-direction: column-reverse;\r\n    gap: 7px;\r\n  }\r\n\r\n  .pi-qa__compose-note {\r\n    margin-left: 0;\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n/* ---------- editor placeholder / preview ---------- */\r\n.pi-qa__placeholder {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 40px 20px;\r\n  border: 2px dashed #c4cdd4;\r\n  border-radius: 10px;\r\n  color: #5b6873;\r\n  text-align: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.pi-qa__placeholder-icon {\r\n  font-size: 28px;\r\n  color: #8997a1;\r\n}\r\n\r\n.pi-qa__placeholder p {\r\n  margin: 0;\r\n}\r\n\r\n.pi-qa--preview .pi-qa__controls {\r\n  pointer-events: none;\r\n}\r\n\r\n.pi-qa--preview .pi-qa__row-main {\r\n  grid-template-columns: auto 1fr;\r\n  align-items: center;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .pi-qa__compose--show,\r\n  .pi-qa__notice--show,\r\n  .pi-qa__answer--show {\r\n    animation: none;\r\n  }\r\n\r\n  .pi-qa__ansdisc svg {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.pi-qa__more-error {\r\n  margin: 8px 0 0;\r\n  color: var(--pi-qa-danger-dark);\r\n  font-size: 0.875rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
